export default class OptionsSelector {
  constructor({ el }) {
    this.el = el;
    this.buttons = Array.from(this.el.querySelectorAll('button.level-1'));
    this.sections = Array.from(this.el.querySelectorAll('.option-content-group'));

    this.init();
  }

  init() {
    this.buttons.forEach((button) => {
      button.addEventListener('click', () => {
        this.buttons.forEach((button) => button.classList.remove('active'));
        button.classList.add('active');

        const target = button.dataset.title;

        this.sections.forEach((section) => {
          section.classList.remove('active');
          if (section.dataset.title === target) {
            section.classList.add('active');
          }
        });
      });
    });
  }
}
